interface ScrollCueState {
  isReady: boolean;
  hasMoreContent: boolean;
  isScrolling: boolean;
}

export interface ScrollCueStore {
  setState: (patch: Partial<ScrollCueState>) => void;
  subscribe: (listener: () => void) => () => void;
  getSnapshot: () => boolean;
}

/** Listeners are notified only when derived visibility flips, so scroll-driven churn re-renders nothing. */
export const createScrollCueStore = (): ScrollCueStore => {
  const state: ScrollCueState = { isReady: false, hasMoreContent: false, isScrolling: false };
  const listeners = new Set<() => void>();
  let isVisible = false;

  return {
    setState: (patch) => {
      Object.assign(state, patch);

      const nextVisible = state.isReady && state.hasMoreContent && !state.isScrolling;

      if (nextVisible === isVisible) {
        return;
      }

      isVisible = nextVisible;
      listeners.forEach((listener) => listener());
    },
    subscribe: (listener) => {
      listeners.add(listener);

      return () => {
        listeners.delete(listener);
      };
    },
    getSnapshot: () => isVisible,
  };
};
